import { h } from 'preact'
import styles from './index.module.css'

type InlineQuoteProps = {
  text: string
}

export function InlineQuote(props: InlineQuoteProps) {
  return <p className={styles.inlineQuote}>{props.text}</p>
}
